import React from 'react';
import { Link } from 'react-router-dom';
import './Logo.css';
import logoImage from '../../assets/logo.webp';

const Logo = () => (
  <div className="logo">
    <Link to="/">
      {/* Add an icon before the text */}
      <img src={logoImage} alt="Digital Fig logo icon" className="logo-icon" />
      <span className="logo-text">
        <span className="logo-main">Digital</span>
        <span className="logo-sub">Fig</span>
      </span>
    </Link>
  </div>
);

export default Logo;